<template>
  <article
    class="contacts-form-component"
    :class="[theme]"
  >
    <VIcon
      v-if="!noClosable"
      class="close-icon"
      material="close"
      @click="onClose"
    />

    <template v-if="isDefaultTheme">
      <header>Связаться с вами</header>

      <p>
        Заполните ваши контактные данные, и наш специалист свяжется с вами в течение одного рабочего
        дня.
      </p>
    </template>

    <p v-if="isNoCategoriesTheme">
      По вашему запросу ничего не найдено. Оставьте заявку на поиск новых позиций сырья и мы найдем
      для вас интересные предложения
    </p>

    <template v-if="isMakeOrderTheme">
      <header>Хотите заказать образец или партию сырья</header>

      <p>Заполните анкету и наш специалист свяжется с вами в течение одного рабочего дня.</p>
    </template>

    <template v-if="isGetCatalogTheme">
      <header>Получить каталог</header>

      <p>
        Заполните анкету и наш специалист отправит вам каталог на почту в течение одного рабочего
        дня.
      </p>
    </template>

    <template v-if="isMakeRecallTheme">
      <header>Заказать звонок</header>

      <p>Заполните анкету и наш специалист свяжется с вами в течение одного рабочего дня.</p>
    </template>

    <VForm ref="form">
      <VInput
        ref="name"
        v-model="form.name"
        label="Имя и фамилия"
        layout="vertical"
        required
				:validate-method="validateName"
      />

      <VInput
        v-if="isGetCatalogTheme"
        ref="email"
        v-model="form.email"
        label="Электронная почта"
        layout="vertical"
        required
        type="email"
				autocomplete="email"
      />

      <VInputPhoneNumber
        v-else
        ref="phone"
        v-model="form.phone"
        label="Телефон"
        layout="vertical"
        required
				:validate-method="validatePhone"
      />
    </VForm>

    <VCheckbox
			v-model="form.agreement"
			required
		>
      Отправляя заявку, я  даю
			<a
				@click.stop
				href="/contracts/permissionForProcessing"
				target="_blank"
			>
				согласие на обработку ПД
			</a>
			и подтверждаю, что ознакомился с
			<a
				@click.stop
				href="/contracts/userConfidential"
				target="_blank"
			>
				политикой в отношении обработки ПД
			</a>
    </VCheckbox>

    <div class="actions">
      <ActionButton
				@click="onSubmit"
			>
        {{ isNoCategoriesTheme ? 'Оставить заявку' : 'Отправить заявку' }}
      </ActionButton>
    </div>
  </article>
</template>

<style lang="scss" src="./ContactsForm.scss" />

<script>

import Core 					 		 from "@/core/Core";

import ActionButton    		 from '../ActionButton/ActionButton.vue';
import VCheckbox 		   		 from "@/lib/components/VCheckbox/VCheckbox.vue";
import VInput 		     		 from "@/lib/components/VInput/VInput.vue";

import VIcon 		       		 from "@/lib/components/VIcon/VIcon.vue";

import ValidationFormMixin from "@/mixins/validation-form-mixin";

export default {
	name: 'ContactsForm',

	components: {
		VInput,
		VCheckbox,
		ActionButton,
		VIcon
	},

	mixins: [ValidationFormMixin],

	props: {
		forceTheme: {
			type: String,
			default: null,
		},

		noClosable: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			form: {
				name: null,
				email: null,
				phone: null,
				agreement: false,
			},
		};
	},

	computed: {
		theme() {
			return Core.utils.string.isNotEmptyString(this.forceTheme)
				? this.forceTheme
				: this.$store.getters['landing/overlayFormTheme'];
		},

		isDefaultTheme() {
			return this.theme === null || this.theme === 'default';
		},

		isNoCategoriesTheme() {
			return !this.isDefaultTheme && this.theme === 'no-categories';
		},

		isGetCatalogTheme() {
			return !this.isDefaultTheme && this.theme === 'get-catalog';
		},

		isMakeOrderTheme() {
			return !this.isDefaultTheme && this.theme === 'make-order';
		},

		isMakeRecallTheme() {
			return !this.isDefaultTheme && this.theme === 'make-recall';
		},

		baseURL() {
			return this.$store.getters['landing/baseURL'];
		},
	},

	methods: {
		onClose() {
			this.$store.dispatch('landing/toggleOverlayForm', null);
			this.resetForm();
		},

		resetForm() {
			this.$refs.form?.reset();

			this.form.name = null;
			this.form.phone = null;
			this.form.email = null;
			this.form.agreement = false;
		},

		validateName(value) {
			if (!Core.utils.validators.name(value)) {
				return Core.utils.validators.MESSAGES.name;
			}

			if (!Core.utils.validators.maxLength(value, 50)) {
				return `${Core.utils.validators.MESSAGES.maxLength} 50 символов`;
			}

			return null;
		},

		validatePhone(value) {
			if (!Core.utils.validators.phone(value)) {
				return Core.utils.validators.MESSAGES.phone;
			}

			if (!Core.utils.validators.maxLength(value, 20)) {
				return `${Core.utils.validators.MESSAGES.maxLength} 20 символов`;
			}

			return null;
		},

		async onSubmit() {
			await this.validate();

			if (this.form.agreement === false) {
				Core.showNotification.info(
					`Перед тем как ${this.isNoCategoriesTheme ? 'оставить заявку' : 'отправить заявку'}, необходимо согласится с условиями передачи информации.`)
				return;
			}

			if (this.isValid) {
				const lead = {
					name: this.form.name,
					email: this.form.email,
					phone: this.form.phone,
					priority: 'medium',
					source: this.theme,
				};

				switch (this.theme) {
					case 'make-recall':
						lead.priority = 'high';
						break;
					case 'get-catalog':
						lead.priority = 'low';
						break;
				}

				Core.rpc.makeLegacyRequest('leads.add', { lead })
					.then(response => {
						const { data } = response || {};

						if (data) {
							this.$store.dispatch('landing/addToast', {
								type: 'success',
								name: lead.name,
							});
							this.onClose();
						} else {
							this.$store.dispatch('landing/addToast', {
								type: 'error',
								name: null,
							});
						}
					});
			}
		},
	},
};
</script>

